module.exports = __webpack_public_path__ + "static/media/TAPNYSwagDesign1.748c0fb4.jpeg";